export enum Permissions {
    AdministrationView = "Frends.Administration.View",
    ApiKeyManagementAdmin = "Frends.ApiKeyManagement.Admin",
    ApiManagementView = "Frends.ApiManagement.View",
    ApiManagementEdit = "Frends.ApiManagement.Edit",
    ApiManagementDeploy = "Frends.ApiManagement.Deploy",
    ApiAccessPolicyManagementAdmin = "Frends.ApiAccessPolicyManagement.Admin",
    EnvironmentEdit = "Frends.Environment.Edit",
    EnvironmentAdmin = "Frends.Environment.Admin",
    EnvironmentVariablesEdit = "Frends.EnvironmentVariables.Edit",
    MonitoringRulesView = "Frends.MonitoringRules.View",
    MonitoringRulesEdit = "Frends.MonitoringRules.Edit",
    ProcessEdit = "Frends.Process.Edit",
    ProcessStart = "Frends.Process.Start",
    ProcessDeploy = "Frends.Process.Deploy",
    ProcessView = "Frends.Process.View",
    ProcessInstanceEdit = "Frends.ProcessInstance.Edit",
    SubProcessEdit = "Frends.Process.Edit",
    TaskView = "Frends.Task.View",
    TaskEdit = "Frends.Task.Edit",
    TaskAdmin = "Frends.Task.Admin",
    UserManagementAdmin = "Frends.UserManagement.Admin",
    SettingsAdmin = "Frends.Settings.Admin"
}

export const AllPermissionsTrue = {
    [Permissions.ApiManagementView]: true,
    [Permissions.ApiManagementEdit]: true,
    [Permissions.ApiManagementDeploy]: true,
    [Permissions.ProcessView]: true,
    [Permissions.ProcessEdit]: true,
    [Permissions.ProcessStart]: true,
    [Permissions.ProcessDeploy]: true,
    [Permissions.EnvironmentVariablesEdit]: true,
    [Permissions.AdministrationView]: true,
    [Permissions.EnvironmentEdit]: true,
    [Permissions.EnvironmentAdmin]: true,
    [Permissions.TaskView]: true,
    [Permissions.TaskEdit]: true,
    [Permissions.TaskAdmin]: true,
    [Permissions.MonitoringRulesView]: true,
    [Permissions.MonitoringRulesEdit]: true,
    [Permissions.UserManagementAdmin]: true,
    [Permissions.ApiKeyManagementAdmin]: true,
    [Permissions.ProcessInstanceEdit]: true,
    [Permissions.ApiAccessPolicyManagementAdmin]: true,
    [Permissions.SettingsAdmin]: true
};
